import React from 'react';

import { InfoProps } from './Info.type';

const Info = (props: InfoProps) => {
	return (
		<div
			className={
				props.variant === 'warning'
					? 'bg-warning-lighter w-full h-10 flex items-center justify-center rounded-lg'
					: props.variant === 'info'
					? 'bg-info-lighter w-full h-10 flex items-center justify-center rounded-lg'
					: 'bg-positive-lighter w-full h-10 flex items-center justify-center rounded-lg'
			}
		>
			<div
				className={
					props.variant === 'warning'
						? 'text-warning-darker laptop:text-regular tablet:text-large mobile:text-regular'
						: props.variant === 'info'
						? 'text-info-darker laptop:text-regular tablet:text-large mobile:text-regular'
						: 'text-positive-darker laptop:text-regular tablet:text-large mobile:text-regular'
				}
			>
				{props.text}
			</div>
		</div>
	);
};

export default Info;
